/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// redux
import {useSelector} from 'react-redux';
// material
import {ListSelectDropDown} from '@insticator/insticator-ui';
import {DEVICES, FILTERS} from "../../consts";

// utils




/* ========== ~~~~~~~~~~ DEVICE FILTER ~~~~~~~~~~ ========== */

export default (props) => {
    // component props
    const {handleOnChange, filterValues} = props;

    // redux state
    const selectedDevices = useSelector((state) => state.app.filters.devices)
    const selected = (filterValues[DEVICES] || []).length ? filterValues[DEVICES] : selectedDevices;

    const getDevices = () => {
        return [
            {value: 'DESKTOP', name: 'Desktop', selected: selected.indexOf('DESKTOP') >= 0},
            {value: 'MOBILE', name: 'Mobile Web', selected: selected.indexOf('MOBILE') >= 0}
        ]
    };

    return (
                <ListSelectDropDown
                    klass={`filter-device`}
                    name={selectedDevices.length === 1 ? 'Device' : 'Devices'}
                    // icon={`mobile-alt`}
                    items={getDevices()}
                    noEmptyApply={true}
                    buttonAction={
                        devices => {
                            const newValue = {[DEVICES]: devices[undefined]}
                            handleOnChange({
                                [FILTERS]: {
                                    ...filterValues,
                                    ...newValue
                                }
                            })
                        }
                    }
                />
    );
};
